// External libraries
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';
import {
    MetricsClickable,
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc/frontend-metrics';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';

// This package
import { DropdownContainer } from '../dropdown';

dayjs.extend(utc);

export class AppointmentItem extends Component {
    static propTypes = {
        appointment: PropTypes.shape({
            request_id: PropTypes.any.isRequired,
            name: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
            time: PropTypes.string.isRequired,
            photo: PropTypes.string.isRequired,
            professionalId: PropTypes.string.isRequired,
        }),
        onUpcomingAppointmentClick: PropTypes.func,
        sendMetric: PropTypes.func,
    };

    static defaultProps = {
        sendMetric: () => {},
    };

    componentDidMount() {
        this.props.sendMetric({
            initiator: EVENT_INITIATORS.SYSTEM,
            interactionType: INTERACTION_TYPES.LOAD,
            ...this.metricsData(),
        });
    }

    render() {
        const { appointment, onUpcomingAppointmentClick } = this.props;

        const { name, title, time, photo, request_id: requestId } = appointment;

        const formattedDate = dayjs.utc(time).format('ddd, MMMM D');
        const formattedTime = dayjs.utc(time).format('h:mm A');

        return (
            <DropdownContainer
                href="/patient/medicalteam"
                itemId={requestId}
                onClick={onUpcomingAppointmentClick}
            >
                <MetricsClickable
                    action="Click PageHeader Notifications UpcomingAppointments"
                    {...this.metricsData()}
                >
                    <AppointmentContainer data-test="appointment-item">
                        <DoctorPhotoWrapper>
                            <DoctorPhoto alt={`${name} ${title}`} src={photo} />
                        </DoctorPhotoWrapper>
                        <DoctorText>
                            <div>
                                {name}, {title}
                            </div>
                            <StyledTime data-test="appointment-item-datetime">
                                {`${formattedDate} - ${formattedTime}`}
                            </StyledTime>
                        </DoctorText>
                    </AppointmentContainer>
                </MetricsClickable>
            </DropdownContainer>
        );
    }

    metricsData = () => {
        const { appointment } = this.props;
        const { professionalId, time, request_id: requestId } = appointment;

        return {
            element: 'UpcomingAppointments',
            eventDetails: {
                RequestId: requestId,
                AppointmentTime: time,
                ProfessionalId: professionalId,
            },
        };
    };
}

const AppointmentContainer = styled.div`
    align-items: center;
    display: flex;
    flex: 1 0 auto;
    justify-content: left;
    overflow: hidden;
`;

const DoctorText = styled.div`
    padding-top: 2px;
    padding-left: 12px;
    color: ${navy};
    font: 18px/20px ${FontFamily.SharpSansBold};
`;

const PHOTO_SIZE_XXS = 44;
const PHOTO_SIZE_S = 64;

const DoctorPhotoWrapper = styled.div`
    overflow: hidden;
    position: relative;
    width: ${PHOTO_SIZE_XXS}px;
    height: ${PHOTO_SIZE_XXS}px;
    border-radius: 50px;
    margin: 8px 4px 8px;

    ${breakpoint.small} {
        width: ${PHOTO_SIZE_S}px;
        height: ${PHOTO_SIZE_S}px;
    }
`;

const DoctorPhoto = styled.img`
    width: ${PHOTO_SIZE_XXS}px;

    ${breakpoint.small} {
        width: ${PHOTO_SIZE_S}px;
    }
`;

const StyledTime = styled.div`
    font: 15px/20px ${FontFamily.SharpSansSemibold};
    margin-top: 5px;
    font-variant-numeric: lining-nums;
`;
